/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@shopify/theme-cart/request.js":
/*!*****************************************************!*\
  !*** ./node_modules/@shopify/theme-cart/request.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cart": () => (/* binding */ cart),
/* harmony export */   "cartAdd": () => (/* binding */ cartAdd),
/* harmony export */   "cartAddFromForm": () => (/* binding */ cartAddFromForm),
/* harmony export */   "cartChange": () => (/* binding */ cartChange),
/* harmony export */   "cartClear": () => (/* binding */ cartClear),
/* harmony export */   "cartUpdate": () => (/* binding */ cartUpdate),
/* harmony export */   "cartShippingRates": () => (/* binding */ cartShippingRates)
/* harmony export */ });
function getDefaultRequestConfig() {
  return JSON.parse(
    JSON.stringify({
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;'
      }
    })
  );
}

function fetchJSON(url, config) {
  return fetch(url, config).then(function(response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
}

function cart() {
  return fetchJSON('/cart.js', getDefaultRequestConfig());
}

function cartAdd(id, quantity, properties) {
  var config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify({
    id: id,
    quantity: quantity,
    properties: properties
  });

  return fetchJSON('/cart/add.js', config);
}

function cartAddFromForm(formData) {
  var config = getDefaultRequestConfig();
  delete config.headers['Content-Type'];

  config.method = 'POST';
  config.body = formData;

  return fetchJSON('/cart/add.js', config);
}

function cartChange(line, options) {
  var config = getDefaultRequestConfig();

  options = options || {};

  config.method = 'POST';
  config.body = JSON.stringify({
    line: line,
    quantity: options.quantity,
    properties: options.properties
  });

  return fetchJSON('/cart/change.js', config);
}

function cartClear() {
  var config = getDefaultRequestConfig();
  config.method = 'POST';

  return fetchJSON('/cart/clear.js', config);
}

function cartUpdate(body) {
  var config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify(body);

  return fetchJSON('/cart/update.js', config);
}

function cartShippingRates() {
  return fetchJSON('/cart/shipping_rates.json', getDefaultRequestConfig());
}


/***/ }),

/***/ "./node_modules/@shopify/theme-cart/theme-cart.js":
/*!********************************************************!*\
  !*** ./node_modules/@shopify/theme-cart/theme-cart.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getState": () => (/* binding */ getState),
/* harmony export */   "getItemIndex": () => (/* binding */ getItemIndex),
/* harmony export */   "getItem": () => (/* binding */ getItem),
/* harmony export */   "addItem": () => (/* binding */ addItem),
/* harmony export */   "addItemFromForm": () => (/* binding */ addItemFromForm),
/* harmony export */   "updateItem": () => (/* binding */ updateItem),
/* harmony export */   "removeItem": () => (/* binding */ removeItem),
/* harmony export */   "clearItems": () => (/* binding */ clearItems),
/* harmony export */   "getAttributes": () => (/* binding */ getAttributes),
/* harmony export */   "updateAttributes": () => (/* binding */ updateAttributes),
/* harmony export */   "clearAttributes": () => (/* binding */ clearAttributes),
/* harmony export */   "getNote": () => (/* binding */ getNote),
/* harmony export */   "updateNote": () => (/* binding */ updateNote),
/* harmony export */   "clearNote": () => (/* binding */ clearNote),
/* harmony export */   "getShippingRates": () => (/* binding */ getShippingRates)
/* harmony export */ });
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./request */ "./node_modules/@shopify/theme-cart/request.js");
/* harmony import */ var _validate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./validate */ "./node_modules/@shopify/theme-cart/validate.js");
/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */




/**
 * Returns the state object of the cart
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function getState() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cart();
}

/**
 * Returns the index of the cart line item
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the index number of the line item
 */
function getItemIndex(key) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);

  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    var index = -1;

    state.items.forEach(function(item, i) {
      index = item.key === key ? i + 1 : index;
    });

    if (index === -1) {
      return Promise.reject(
        new Error('Theme Cart: Unable to match line item with provided key')
      );
    }

    return index;
  });
}

/**
 * Fetches the line item object
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */
function getItem(key) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);

  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    var lineItem = null;

    state.items.forEach(function(item) {
      lineItem = item.key === key ? item : lineItem;
    });

    if (lineItem === null) {
      return Promise.reject(
        new Error('Theme Cart: Unable to match line item with provided key')
      );
    }

    return lineItem;
  });
}

/**
 * Add a new line item to the cart
 * @param {number} id The variant's unique ID
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */
function addItem(id, options) {
  options = options || {};

  _validate__WEBPACK_IMPORTED_MODULE_1__.id(id);

  return _request__WEBPACK_IMPORTED_MODULE_0__.cartAdd(id, options.quantity, options.properties);
}

/**
 * Add a new line item to the cart from a product form
 * @param {object} form DOM element which is equal to the <form> node
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */
function addItemFromForm(form) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.form(form);

  var formData = new FormData(form);
  _validate__WEBPACK_IMPORTED_MODULE_1__.id(parseInt(formData.get('id'), 10));

  return _request__WEBPACK_IMPORTED_MODULE_0__.cartAddFromForm(formData);
}

/**
 * Changes the quantity and/or properties of an existing line item.
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function updateItem(key, options) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);
  _validate__WEBPACK_IMPORTED_MODULE_1__.options(options);

  return getItemIndex(key).then(function(line) {
    return _request__WEBPACK_IMPORTED_MODULE_0__.cartChange(line, options);
  });
}

/**
 * Removes a line item from the cart
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function removeItem(key) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);

  return getItemIndex(key).then(function(line) {
    return _request__WEBPACK_IMPORTED_MODULE_0__.cartChange(line, { quantity: 0 });
  });
}

/**
 * Sets all quantities of all line items in the cart to zero. This does not remove cart attributes nor the cart note.
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function clearItems() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartClear();
}

/**
 * Gets all cart attributes
 * @returns {Promise} Resolves with the cart attributes object
 */
function getAttributes() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    return state.attributes;
  });
}

/**
 * Sets all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */
function updateAttributes(attributes) {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartUpdate({ attributes: attributes });
}

/**
 * Clears all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */
function clearAttributes() {
  return getAttributes().then(function(attributes) {
    for (var key in attributes) {
      attributes[key] = '';
    }
    return updateAttributes(attributes);
  });
}

/**
 * Gets cart note
 * @returns {Promise} Resolves with the cart note string
 */
function getNote() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    return state.note;
  });
}

/**
 * Sets cart note
 * @returns {Promise} Resolves with the cart state object
 */
function updateNote(note) {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartUpdate({ note: note });
}

/**
 * Clears cart note
 * @returns {Promise} Resolves with the cart state object
 */
function clearNote() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartUpdate({ note: '' });
}

/**
 * Get estimated shipping rates.
 * @returns {Promise} Resolves with response of /cart/shipping_rates.json (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-shipping-rates)
 */
function getShippingRates() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartShippingRates();
}


/***/ }),

/***/ "./node_modules/@shopify/theme-cart/validate.js":
/*!******************************************************!*\
  !*** ./node_modules/@shopify/theme-cart/validate.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "key": () => (/* binding */ key),
/* harmony export */   "quantity": () => (/* binding */ quantity),
/* harmony export */   "id": () => (/* binding */ id),
/* harmony export */   "properties": () => (/* binding */ properties),
/* harmony export */   "form": () => (/* binding */ form),
/* harmony export */   "options": () => (/* binding */ options)
/* harmony export */ });
function key(key) {
  if (typeof key !== 'string' || key.split(':').length !== 2) {
    throw new TypeError(
      'Theme Cart: Provided key value is not a string with the format xxx:xxx'
    );
  }
}

function quantity(quantity) {
  if (typeof quantity !== 'number' || isNaN(quantity)) {
    throw new TypeError(
      'Theme Cart: An object which specifies a quantity or properties value is required'
    );
  }
}

function id(id) {
  if (typeof id !== 'number' || isNaN(id)) {
    throw new TypeError('Theme Cart: Variant ID must be a number');
  }
}

function properties(properties) {
  if (typeof properties !== 'object') {
    throw new TypeError('Theme Cart: Properties must be an object');
  }
}

function form(form) {
  if (!(form instanceof HTMLFormElement)) {
    throw new TypeError('Theme Cart: Form must be an instance of HTMLFormElement');
  }
}

function options(options) {
  if (typeof options !== 'object') {
    throw new TypeError('Theme Cart: Options must be an object');
  }

  if (
    typeof options.quantity === 'undefined' &&
    typeof options.properties === 'undefined'
  ) {
    throw new Error(
      'Theme Cart: You muse define a value for quantity or properties'
    );
  }

  if (typeof options.quantity !== 'undefined') {
    quantity(options.quantity);
  }

  if (typeof options.properties !== 'undefined') {
    properties(options.properties);
  }
}


/***/ }),

/***/ "./node_modules/@shopify/theme-product-form/listeners.js":
/*!***************************************************************!*\
  !*** ./node_modules/@shopify/theme-product-form/listeners.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Listeners)
/* harmony export */ });
function Listeners() {
  this.entries = [];
}

Listeners.prototype.add = function(element, event, fn) {
  this.entries.push({ element: element, event: event, fn: fn });
  element.addEventListener(event, fn);
};

Listeners.prototype.removeAll = function() {
  this.entries = this.entries.filter(function(listener) {
    listener.element.removeEventListener(listener.event, listener.fn);
    return false;
  });
};


/***/ }),

/***/ "./node_modules/@shopify/theme-product-form/theme-product-form.js":
/*!************************************************************************!*\
  !*** ./node_modules/@shopify/theme-product-form/theme-product-form.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getUrlWithVariant": () => (/* binding */ getUrlWithVariant),
/* harmony export */   "ProductForm": () => (/* binding */ ProductForm)
/* harmony export */ });
/* harmony import */ var _listeners__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./listeners */ "./node_modules/@shopify/theme-product-form/listeners.js");
/* harmony import */ var _shopify_theme_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @shopify/theme-product */ "./node_modules/@shopify/theme-product/theme-product.js");



var selectors = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  quantityInput: '[name="quantity"]',
  propertyInput: '[name^="properties"]'
};

// Public Methods
// -----------------------------------------------------------------------------

/**
 * Returns a URL with a variant ID query parameter. Useful for updating window.history
 * with a new URL based on the currently select product variant.
 * @param {string} url - The URL you wish to append the variant ID to
 * @param {number} id  - The variant ID you wish to append to the URL
 * @returns {string} - The new url which includes the variant ID query parameter
 */

function getUrlWithVariant(url, id) {
  if (/variant=/.test(url)) {
    return url.replace(/(variant=)[^&]+/, '$1' + id);
  } else if (/\?/.test(url)) {
    return url.concat('&variant=').concat(id);
  }

  return url.concat('?variant=').concat(id);
}

/**
 * Constructor class that creates a new instance of a product form controller.
 *
 * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
 * @param {Object} product - A product object
 * @param {Object} options - Optional options object
 * @param {Function} options.onOptionChange - Callback for whenever an option input changes
 * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
 * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
 * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
 */
function ProductForm(element, product, options) {
  this.element = element;
  this.product = _validateProductObject(product);

  options = options || {};

  this._listeners = new _listeners__WEBPACK_IMPORTED_MODULE_0__["default"]();
  this._listeners.add(
    this.element,
    'submit',
    this._onSubmit.bind(this, options)
  );

  this.optionInputs = this._initInputs(
    selectors.optionInput,
    options.onOptionChange
  );

  this.quantityInputs = this._initInputs(
    selectors.quantityInput,
    options.onQuantityChange
  );

  this.propertyInputs = this._initInputs(
    selectors.propertyInput,
    options.onPropertyChange
  );
}

/**
 * Cleans up all event handlers that were assigned when the Product Form was constructed.
 * Useful for use when a section needs to be reloaded in the theme editor.
 */
ProductForm.prototype.destroy = function() {
  this._listeners.removeAll();
};

/**
 * Getter method which returns the array of currently selected option values
 *
 * @returns {Array} An array of option values
 */
ProductForm.prototype.options = function() {
  return _serializeOptionValues(this.optionInputs, function(item) {
    var regex = /(?:^(options\[))(.*?)(?:\])/;
    item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
    return item;
  });
};

/**
 * Getter method which returns the currently selected variant, or `null` if variant
 * doesn't exist.
 *
 * @returns {Object|null} Variant object
 */
ProductForm.prototype.variant = function() {
  return (0,_shopify_theme_product__WEBPACK_IMPORTED_MODULE_1__.getVariantFromSerializedArray)(this.product, this.options());
};

/**
 * Getter method which returns a collection of objects containing name and values
 * of property inputs
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.properties = function() {
  var properties = _serializePropertyValues(this.propertyInputs, function(
    propertyName
  ) {
    var regex = /(?:^(properties\[))(.*?)(?:\])/;
    var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
    return name;
  });

  return Object.entries(properties).length === 0 ? null : properties;
};

/**
 * Getter method which returns the current quantity or 1 if no quantity input is
 * included in the form
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.quantity = function() {
  return this.quantityInputs[0]
    ? Number.parseInt(this.quantityInputs[0].value, 10)
    : 1;
};

// Private Methods
// -----------------------------------------------------------------------------
ProductForm.prototype._setIdInputValue = function(value) {
  var idInputElement = this.element.querySelector(selectors.idInput);

  if (!idInputElement) {
    idInputElement = document.createElement('input');
    idInputElement.type = 'hidden';
    idInputElement.name = 'id';
    this.element.appendChild(idInputElement);
  }

  idInputElement.value = value.toString();
};

ProductForm.prototype._onSubmit = function(options, event) {
  event.dataset = this._getProductFormEventData();

  if (event.dataset.variant) {
    this._setIdInputValue(event.dataset.variant.id);
  }

  if (options.onFormSubmit) {
    options.onFormSubmit(event);
  }
};

ProductForm.prototype._onFormEvent = function(cb) {
  if (typeof cb === 'undefined') {
    return Function.prototype;
  }

  return function(event) {
    event.dataset = this._getProductFormEventData();
    cb(event);
  }.bind(this);
};

ProductForm.prototype._initInputs = function(selector, cb) {
  var elements = Array.prototype.slice.call(
    this.element.querySelectorAll(selector)
  );

  return elements.map(
    function(element) {
      this._listeners.add(element, 'change', this._onFormEvent(cb));
      return element;
    }.bind(this)
  );
};

ProductForm.prototype._getProductFormEventData = function() {
  return {
    options: this.options(),
    variant: this.variant(),
    properties: this.properties(),
    quantity: this.quantity()
  };
};

function _serializeOptionValues(inputs, transform) {
  return inputs.reduce(function(options, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      options.push(transform({ name: input.name, value: input.value }));
    }

    return options;
  }, []);
}

function _serializePropertyValues(inputs, transform) {
  return inputs.reduce(function(properties, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      properties[transform(input.name)] = input.value;
    }

    return properties;
  }, {});
}

function _validateProductObject(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (typeof product.variants[0].options === 'undefined') {
    throw new TypeError(
      'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route'
    );
  }

  return product;
}


/***/ }),

/***/ "./node_modules/@shopify/theme-product/theme-product.js":
/*!**************************************************************!*\
  !*** ./node_modules/@shopify/theme-product/theme-product.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getProductJson": () => (/* binding */ getProductJson),
/* harmony export */   "getVariantFromId": () => (/* binding */ getVariantFromId),
/* harmony export */   "getVariantFromSerializedArray": () => (/* binding */ getVariantFromSerializedArray),
/* harmony export */   "getVariantFromOptionArray": () => (/* binding */ getVariantFromOptionArray)
/* harmony export */ });
/**
 * Returns a product JSON object when passed a product URL
 * @param {*} url
 */
function getProductJson(handle) {
  return fetch('/products/' + handle + '.js').then(function(response) {
    return response.json();
  });
}

/**
 * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Number} value Accepts Number (e.g. 6908023078973)
 * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
 */
function getVariantFromId(product, value) {
  _validateProductStructure(product);

  if (typeof value !== 'number') {
    throw new TypeError(value + ' is not a Number.');
  }

  var result = product.variants.filter(function(variant) {
    return variant.id === value;
  });

  return result[0] || null;
}

/**
 * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromSerializedArray(product, collection) {
  _validateProductStructure(product);

  // If value is an array of options
  var optionArray = _createOptionArrayFromOptionCollection(product, collection);
  return getVariantFromOptionArray(product, optionArray);
}

/**
 * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);

  var result = product.variants.filter(function(variant) {
    return options.every(function(option, index) {
      return variant.options[index] === option;
    });
  });

  return result[0] || null;
}

/**
 * Creates an array of selected options from the object
 * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
 * @param {Object} product Product JSON object
 * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
 */
function _createOptionArrayFromOptionCollection(product, collection) {
  _validateProductStructure(product);
  _validateSerializedArray(collection);

  var optionArray = [];

  collection.forEach(function(option) {
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
        optionArray[i] = option.value;
        break;
      }
    }
  });

  return optionArray;
}

/**
 * Check if the product data is a valid JS object
 * Error will be thrown if type is invalid
 * @param {object} product Product JSON object
 */
function _validateProductStructure(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + ' is empty.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted like jQuery's serializeArray()
 * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
 */
function _validateSerializedArray(collection) {
  if (!Array.isArray(collection)) {
    throw new TypeError(collection + ' is not an array.');
  }

  if (collection.length === 0) {
    return [];
  }

  if (collection[0].hasOwnProperty('name')) {
    if (typeof collection[0].name !== 'string') {
      throw new TypeError(
        'Invalid value type passed for name of option ' +
          collection[0].name +
          '. Value should be string.'
      );
    }
  } else {
    throw new Error(collection[0] + 'does not contain name key.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted as list of values
 * @param {Array} collection Array of object (e.g. ['36', 'Black'])
 */
function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === 'object') {
    throw new Error(options + 'is not a valid array of options.');
  }
}


/***/ }),

/***/ "./node_modules/@shopify/theme-sections/section.js":
/*!*********************************************************!*\
  !*** ./node_modules/@shopify/theme-sections/section.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Section)
/* harmony export */ });
var SECTION_ID_ATTR = 'data-section-id';

function Section(container, properties) {
  this.container = validateContainerElement(container);
  this.id = container.getAttribute(SECTION_ID_ATTR);
  this.extensions = [];

  // eslint-disable-next-line es5/no-es6-static-methods
  Object.assign(this, validatePropertiesObject(properties));

  this.onLoad();
}

Section.prototype = {
  onLoad: Function.prototype,
  onUnload: Function.prototype,
  onSelect: Function.prototype,
  onDeselect: Function.prototype,
  onBlockSelect: Function.prototype,
  onBlockDeselect: Function.prototype,

  extend: function extend(extension) {
    this.extensions.push(extension); // Save original extension

    // eslint-disable-next-line es5/no-es6-static-methods
    var extensionClone = Object.assign({}, extension);
    delete extensionClone.init; // Remove init function before assigning extension properties

    // eslint-disable-next-line es5/no-es6-static-methods
    Object.assign(this, extensionClone);

    if (typeof extension.init === 'function') {
      extension.init.apply(this);
    }
  }
};

function validateContainerElement(container) {
  if (!(container instanceof Element)) {
    throw new TypeError(
      'Theme Sections: Attempted to load section. The section container provided is not a DOM element.'
    );
  }
  if (container.getAttribute(SECTION_ID_ATTR) === null) {
    throw new Error(
      'Theme Sections: The section container provided does not have an id assigned to the ' +
        SECTION_ID_ATTR +
        ' attribute.'
    );
  }

  return container;
}

function validatePropertiesObject(value) {
  if (
    (typeof value !== 'undefined' && typeof value !== 'object') ||
    value === null
  ) {
    throw new TypeError(
      'Theme Sections: The properties object provided is not a valid'
    );
  }

  return value;
}

// Object.assign() polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target) {
      // .length of function is 2
      'use strict';
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}


/***/ }),

/***/ "./node_modules/@shopify/theme-sections/theme-sections.js":
/*!****************************************************************!*\
  !*** ./node_modules/@shopify/theme-sections/theme-sections.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "registered": () => (/* binding */ registered),
/* harmony export */   "instances": () => (/* binding */ instances),
/* harmony export */   "register": () => (/* binding */ register),
/* harmony export */   "unregister": () => (/* binding */ unregister),
/* harmony export */   "load": () => (/* binding */ load),
/* harmony export */   "unload": () => (/* binding */ unload),
/* harmony export */   "extend": () => (/* binding */ extend),
/* harmony export */   "getInstances": () => (/* binding */ getInstances),
/* harmony export */   "getInstanceById": () => (/* binding */ getInstanceById),
/* harmony export */   "isInstance": () => (/* binding */ isInstance)
/* harmony export */ });
/* harmony import */ var _section__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./section */ "./node_modules/@shopify/theme-sections/section.js");
/*
 * @shopify/theme-sections
 * -----------------------------------------------------------------------------
 *
 * A framework to provide structure to your Shopify sections and a load and unload
 * lifecycle. The lifecycle is automatically connected to theme editor events so
 * that your sections load and unload as the editor changes the content and
 * settings of your sections.
 */



var SECTION_TYPE_ATTR = 'data-section-type';
var SECTION_ID_ATTR = 'data-section-id';

window.Shopify = window.Shopify || {};
window.Shopify.theme = window.Shopify.theme || {};
window.Shopify.theme.sections = window.Shopify.theme.sections || {};

var registered = (window.Shopify.theme.sections.registered =
  window.Shopify.theme.sections.registered || {});
var instances = (window.Shopify.theme.sections.instances =
  window.Shopify.theme.sections.instances || []);

function register(type, properties) {
  if (typeof type !== 'string') {
    throw new TypeError(
      'Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered'
    );
  }

  if (typeof registered[type] !== 'undefined') {
    throw new Error(
      'Theme Sections: A section of type "' +
        type +
        '" has already been registered. You cannot register the same section type twice'
    );
  }

  function TypedSection(container) {
    _section__WEBPACK_IMPORTED_MODULE_0__["default"].call(this, container, properties);
  }

  TypedSection.constructor = _section__WEBPACK_IMPORTED_MODULE_0__["default"];
  TypedSection.prototype = Object.create(_section__WEBPACK_IMPORTED_MODULE_0__["default"].prototype);
  TypedSection.prototype.type = type;

  return (registered[type] = TypedSection);
}

function unregister(types) {
  types = normalizeType(types);

  types.forEach(function(type) {
    delete registered[type];
  });
}

function load(types, containers) {
  types = normalizeType(types);

  if (typeof containers === 'undefined') {
    containers = document.querySelectorAll('[' + SECTION_TYPE_ATTR + ']');
  }

  containers = normalizeContainers(containers);

  types.forEach(function(type) {
    var TypedSection = registered[type];

    if (typeof TypedSection === 'undefined') {
      return;
    }

    containers = containers.filter(function(container) {
      // Filter from list of containers because container already has an instance loaded
      if (isInstance(container)) {
        return false;
      }

      // Filter from list of containers because container doesn't have data-section-type attribute
      if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
        return false;
      }

      // Keep in list of containers because current type doesn't match
      if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
        return true;
      }

      instances.push(new TypedSection(container));

      // Filter from list of containers because container now has an instance loaded
      return false;
    });
  });
}

function unload(selector) {
  var instancesToUnload = getInstances(selector);

  instancesToUnload.forEach(function(instance) {
    var index = instances
      .map(function(e) {
        return e.id;
      })
      .indexOf(instance.id);
    instances.splice(index, 1);
    instance.onUnload();
  });
}

function extend(selector, extension) {
  var instancesToExtend = getInstances(selector);

  instancesToExtend.forEach(function(instance) {
    instance.extend(extension);
  });
}

function getInstances(selector) {
  var filteredInstances = [];

  // Fetch first element if its an array
  if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
    var firstElement = selector[0];
  }

  // If selector element is DOM element
  if (selector instanceof Element || firstElement instanceof Element) {
    var containers = normalizeContainers(selector);

    containers.forEach(function(container) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.container === container;
        })
      );
    });

    // If select is type string
  } else if (typeof selector === 'string' || typeof firstElement === 'string') {
    var types = normalizeType(selector);

    types.forEach(function(type) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.type === type;
        })
      );
    });
  }

  return filteredInstances;
}

function getInstanceById(id) {
  var instance;

  for (var i = 0; i < instances.length; i++) {
    if (instances[i].id === id) {
      instance = instances[i];
      break;
    }
  }
  return instance;
}

function isInstance(selector) {
  return getInstances(selector).length > 0;
}

function normalizeType(types) {
  // If '*' then fetch all registered section types
  if (types === '*') {
    types = Object.keys(registered);

    // If a single section type string is passed, put it in an array
  } else if (typeof types === 'string') {
    types = [types];

    // If single section constructor is passed, transform to array with section
    // type string
  } else if (types.constructor === _section__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    types = [types.prototype.type];

    // If array of typed section constructors is passed, transform the array to
    // type strings
  } else if (Array.isArray(types) && types[0].constructor === _section__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    types = types.map(function(TypedSection) {
      return TypedSection.prototype.type;
    });
  }

  types = types.map(function(type) {
    return type.toLowerCase();
  });

  return types;
}

function normalizeContainers(containers) {
  // Nodelist with entries
  if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
    containers = Array.prototype.slice.call(containers);

    // Empty Nodelist
  } else if (
    NodeList.prototype.isPrototypeOf(containers) &&
    containers.length === 0
  ) {
    containers = [];

    // Handle null (document.querySelector() returns null with no match)
  } else if (containers === null) {
    containers = [];

    // Single DOM element
  } else if (!Array.isArray(containers) && containers instanceof Element) {
    containers = [containers];
  }

  return containers;
}

if (window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      '[' + SECTION_ID_ATTR + '="' + id + '"]'
    );

    if (container !== null) {
      load(container.getAttribute(SECTION_TYPE_ATTR), container);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      '[' + SECTION_ID_ATTR + '="' + id + '"]'
    );
    var instance = getInstances(container)[0];

    if (typeof instance === 'object') {
      unload(container);
    }
  });

  document.addEventListener('shopify:section:select', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onSelect(event);
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onDeselect(event);
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onBlockSelect(event);
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onBlockDeselect(event);
    }
  });
}


/***/ }),

/***/ "./src/assets/js/theme.js":
/*!********************************!*\
  !*** ./src/assets/js/theme.js ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lazysizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lazysizes */ "./node_modules/lazysizes/lazysizes.js");
/* harmony import */ var lazysizes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lazysizes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @shopify/theme-sections */ "./node_modules/@shopify/theme-sections/theme-sections.js");
/* harmony import */ var _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @shopify/theme-product-form */ "./node_modules/@shopify/theme-product-form/theme-product-form.js");
/* harmony import */ var _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @shopify/theme-cart */ "./node_modules/@shopify/theme-cart/theme-cart.js");
/* harmony import */ var lazysizes_plugins_unveilhooks_ls_unveilhooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lazysizes/plugins/unveilhooks/ls.unveilhooks */ "./node_modules/lazysizes/plugins/unveilhooks/ls.unveilhooks.js");
/* harmony import */ var lazysizes_plugins_unveilhooks_ls_unveilhooks__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lazysizes_plugins_unveilhooks_ls_unveilhooks__WEBPACK_IMPORTED_MODULE_4__);





(lazysizes__WEBPACK_IMPORTED_MODULE_0___default().cfg.loadHidden) = false;

(function () {
  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};

  var bootTheme = function bootTheme() {
    // Some polyfills not provided yet by polyfills.io
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;

        for (var i = 0; i < this.length; i++) {
          callback.call(thisArg, this[i], i, this);
        }
      };
    }

    var _classCallCheck = function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };

    var _defineProperties = function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    };

    var _createClass = function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    };

    var QuantityPicker = function () {
      function QuantityPicker(element) {
        _classCallCheck(this, QuantityPicker);

        this.element = element ? element : document;
        this.qty_selectors = this.element.querySelectorAll('.quantity-box,.qty-picker'); // this.options = options;

        this._attachListeners();
      }

      _createClass(QuantityPicker, [{
        key: "_attachListeners",
        value: function _attachListeners() {
          var _this = this;

          if (this.qty_selectors && this.qty_selectors.length > 0) {
            this.qty_selectors.forEach(function (el) {
              var button1 = el.querySelector('button.minus-btn,button.minus');
              var button2 = el.querySelector('button.plus-btn,button.plus');
              var qty_el = el.querySelector('input');
              button1.addEventListener('click', _this._quantityMinus.bind(_this, qty_el));
              button2.addEventListener('click', _this._quantityPlus.bind(_this, qty_el));
              qty_el.addEventListener('blur', _this._onInputBlur.bind(_this));
            });
          }
        }
      }, {
        key: "_quantityMinus",
        value: function _quantityMinus(qty_el) {
          var min = qty_el.getAttribute('data-min') * 1;
          var num = qty_el.value * 1;

          if (isNaN(num)) {
            num = min;
          }

          qty_el.value = num - 1 < min ? min : num - 1;
          qty_el.dispatchEvent(new Event("change"));
        }
      }, {
        key: "_quantityPlus",
        value: function _quantityPlus(qty_el) {
          var num = qty_el.value * 1;
          var max = qty_el.dataset.max * 1;

          if (isNaN(num)) {
            num = 0;
          }

          if (!isNaN(max) && max != 0 && num >= max) {
            num = max - 1;
          }

          qty_el.value = num + 1;
          qty_el.dispatchEvent(new Event("change"));
        }
      }, {
        key: "_onInputBlur",
        value: function _onInputBlur(e) {
          var min = e.target.getAttribute('data-min') * 1;
          var default_value = e.target.getAttribute('data-default') * 1;

          if (isNaN(e.target.value)) {
            e.target.value = default_value ? default_value : min;
          }

          ;
        }
      }]);

      return QuantityPicker;
    }();

    new QuantityPicker();
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('cart-drawer', {
      onLoad: function onLoad() {
        this.attachListeners();
        this.ajax_timer = null;
        this.cart = this.container.querySelector('form#cart');
        window.Shopify.theme.cart = this;
        this.setupForms();
        this.setupUpsell();
      },
      setupForms: function setupForms() {
        var _this2 = this;

        document.querySelectorAll('[data-product-form]').forEach(function (formElement) {
          var productHandle = formElement.dataset.productHandle;

          if (productHandle) {
            fetch("/products/".concat(productHandle, ".js")).then(function (response) {
              return response.json();
            }).then(function (productJSON) {
              _this2.productForm = new _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_2__.ProductForm(formElement, productJSON, {
                onFormSubmit: _this2._onFormSubmit.bind(formElement),
                onQuantityChange: function onQuantityChange() {},
                onOptionChange: _this2._onOptionChange.bind(formElement)
              });
            });
          }
        });
      },
      _onOptionChange: function _onOptionChange(event) {
        var variant = event.dataset.variant;
        var formElement = this;
        var btn_atc = formElement.querySelector('[type="submit"]');
        var btc_text = btn_atc.querySelector('.text');

        if (variant === null || variant && !variant.available) {
          btn_atc.setAttribute('disabled', true);
          btc_text.innerHTML = window.languages.productFormUnavailable;
        } else if (variant && variant.available) {
          btn_atc.removeAttribute('disabled');
          btc_text.innerHTML = window.languages.productFormAddToCart;
        }

        if (!variant) {
          return;
        }

        var url = _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_2__.getUrlWithVariant(window.location.href, variant.id);
        window.history.replaceState({
          path: url
        }, '', url);
      },
      _onFormSubmit: function _onFormSubmit(event) {
        var form = this;
        var btn = form.querySelector('[type="submit"]');
        btn.classList.add('adding-to-cart');
        event.preventDefault();
        _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.addItemFromForm(form).then(function (item) {})["catch"](function (error) {
          console.log('A problem occured adding to cart');
        })["finally"](function () {
          btn.classList.remove('adding-to-cart');

          window.Shopify.theme.cart._updateCart();

          window.Shopify.theme.cart.openCart();
        });
      },
      setupUpsell: function setupUpsell() {
        var _this3 = this;

        this.swiper = new Swiper(".mini-cart-swiper-container", {
          spaceBetween: 50,
          slidesPerView: 1,
          navigation: {
            nextEl: ".mini-cart-right-arrow",
            prevEl: ".mini-cart-left-arrow"
          },
          pagination: {
            el: ".swiper-pagination"
          }
        });
        this.container.querySelector('.mini-cart-swiper-container').addEventListener('click', function (event) {
          var button = event.target.closest('.btn-add-upsell') || event.target.classList.contains('btn-add-upsell') && event.target;

          if (button) {
            var id = button.dataset.productId;
            _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.addItem(id * 1).then(function (item) {})["catch"](function () {
              console.log('An error occured');
            })["finally"](function () {
              _this3._updateCart();
            });
            event.preventDefault();
          }
        });
      },
      attachListeners: function attachListeners() {
        var _this4 = this;

        this.container.querySelectorAll('.quantity-box input').forEach(function (el) {
          return el.addEventListener('change', _this4._onQuantityChange.bind(_this4));
        });
        this.container.querySelectorAll('.delete-btn').forEach(function (el) {
          return el.addEventListener('click', _this4._deleteItem.bind(_this4));
        });
      },
      _onQuantityChange: function _onQuantityChange(event) {
        var _this5 = this;

        var input = event.currentTarget;
        var quantity = input.value * 1;
        input.closest('.cart-item').querySelectorAll('.quantity-box input').forEach(function (el) {
          return el.value = input.value;
        });
        var btns = input.closest('.cart-item').querySelectorAll('.quantity-box button');
        var key = input.dataset.key;

        if (key && !isNaN(quantity)) {
          clearTimeout(this.ajax_timer);
          this.ajax_timer = setTimeout(function () {
            btns.forEach(function (el) {
              return el.disabled = true;
            });
            _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.updateItem(key, {
              quantity: quantity
            }).then(function (state) {
              // var item = state.items.find(item => item.key === key);
              // console.log(`The item with key '${key}' now has quantity ${item.quantity}`);
              _this5._updateCart();
            })["catch"](function (error) {
              console.log('A problem occured adding to cart');
            })["finally"](function () {
              btns.forEach(function (el) {
                return el.disabled = false;
              });
            });
          }, 400);
        }
      },
      _deleteItem: function _deleteItem(event) {
        var _this6 = this;

        var target = event.currentTarget;
        var key = target.dataset.key;
        _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.removeItem(key).then(function (state) {
          _this6._updateCart();
        });
        event.preventDefault();
      },
      _updateCart: function _updateCart() {
        var _this7 = this;

        var cartUrl = "".concat(window.routes.cart_url, "?section_id=cart-sidebar-template");
        fetch(cartUrl).then(function (response) {
          return response.text();
        }).then(function (cart) {
          if (cart.trim() === '') {
            return;
          }

          var tempDiv = document.createElement("div");
          tempDiv.innerHTML = cart;
          var cart = tempDiv.querySelector('#cart');

          if (_this7.cart) {
            var cart_items = tempDiv.querySelector('#total_items').innerHTML;
            var empty = !(cart_items > 0);
            document.querySelector('.header .noti-class').classList.toggle('hidden', empty);

            _this7.cart.querySelector('.subtotal-box').classList.toggle('hidden', empty);

            _this7.cart.querySelector('[name="checkout"]').disabled = empty;
            _this7.cart.querySelector('.cart-items').innerHTML = tempDiv.querySelector('.cart-items').innerHTML;
            _this7.cart.querySelector('.cart-total').innerHTML = tempDiv.querySelector('.cart-total').innerHTML;
            var upsell = tempDiv.querySelector('.cart-upsell');

            _this7.cart.querySelector('.cart-upsell').classList.toggle('hidden', !upsell.querySelector('.upsell-item'));

            _this7.cart.querySelector('.cart-upsell .swiper-wrapper').innerHTML = tempDiv.querySelector('.cart-upsell .swiper-wrapper').innerHTML;

            _this7.swiper.update();

            _this7.attachListeners();

            new QuantityPicker(_this7.cart);
          }
        });
      },
      openCart: function openCart() {
        document.body.classList.add('cart-sidebar-open');
      },
      closeCart: function closeCart() {
        document.body.classList.remove('cart-sidebar-open');
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('collection-section', {
      onLoad: function onLoad() {
        this.attachListeners();
      },
      attachListeners: function attachListeners() {
        var _this8 = this;

        this.container.querySelectorAll('.btn-collection-filter,.close_btn').forEach(function (el) {
          return el.addEventListener('click', _this8.toggleFilter.bind(_this8));
        });
        this.container.querySelectorAll('.btn-sortby,.btn-sortby-close').forEach(function (el) {
          return el.addEventListener('click', _this8.toggleSortby.bind(_this8));
        });
      },
      toggleFilter: function toggleFilter(event) {
        document.body.classList.toggle('open-collection-filter');
        event.preventDefault();
      },
      toggleSortby: function toggleSortby(event) {
        document.body.classList.toggle('open-collection-sortby');
        event.preventDefault();
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('cart-drawer', document.querySelector('[data-section-type="cart-drawer"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('collection-section', document.querySelector('[data-section-type="collection-section"]'));

    (function () {
      var links = document.links;

      for (var i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname !== "" && links[i].hostname !== window.location.hostname) {
          links[i].target = '_blank';
          links[i].rel = 'noreferrer noopener';
        }
      }
    })();
  };

  document.addEventListener("DOMContentLoaded", function () {
    var video = document.getElementById('video-src');
    var toggleButton = document.getElementById('play-btn');
    var altToggle = document.getElementById('alt-play-btn');
    var videoCover = document.getElementById('video-cover');
    toggleButton.addEventListener('click', function () {
      if (video.paused) {
        videoCover.style.display = 'none';
        video.play();
        toggleButton.classList.add('opacity-0');
      } else {
        video.pause();
        toggleButton.classList.remove('opacity-0');
      }
    });
    altToggle.addEventListener('click', function () {
      if (video.paused) {
        videoCover.style.display = 'none';
        video.play();
        toggleButton.classList.add('opacity-0');
      } else {
        video.pause();
        toggleButton.classList.remove('opacity-0');
      }
    });
  });

  var docReady = function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
      // call on next available tick
      setTimeout(fn, 1);
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  };

  docReady(function () {
    if ('fetch' in window && 'assign' in Object) {
      bootTheme();
    } else {
      var scriptEl = document.createElement('script');
      scriptEl.src = '//cdn.polyfill.io/v3/polyfill.min.js?unknown=polyfill&features=fetch,Element.prototype.closest,Element.prototype.matches,Element.prototype.remove,Element.prototype.classList,Array.prototype.includes,String.prototype.includes,Object.assign,CustomEvent,URL,DOMTokenList';
      scriptEl.async = false;

      scriptEl.onload = function () {
        bootTheme();
      };

      document.head.appendChild(scriptEl);
    }
  });
})();

/***/ }),

/***/ "./node_modules/lazysizes/lazysizes.js":
/*!*********************************************!*\
  !*** ./node_modules/lazysizes/lazysizes.js ***!
  \*********************************************/
/***/ ((module) => {

(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if( true && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, 
/**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */
function l(window, document, Date) { // Pass in the window Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes,
		/**
		 * @type { LazySizesConfigPartial }
		 */
		lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			fastLoadedClass: 'ls-is-cached',
			iframeLoadMode: 0,
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			/**
			 * @type { LazySizesConfigPartial }
			 */
			cfg: lazySizesCfg,
			/**
			 * @type { true }
			 */
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	/**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */
	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	/**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */
	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

			// loadMode can be also a string!
			if (loadMode == 0) {
				elem.contentWindow.location.replace(src);
			} else if (loadMode == 1) {
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, lazySizesCfg.fastLoadedClass);
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		/**
		 *
		 * @param elem { Element }
		 */
		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		/**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		/**
		 * @type { LazySizesConfigPartial }
		 */
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),

/***/ "./node_modules/lazysizes/plugins/unveilhooks/ls.unveilhooks.js":
/*!**********************************************************************!*\
  !*** ./node_modules/lazysizes/plugins/unveilhooks/ls.unveilhooks.js ***!
  \**********************************************************************/
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
This plugin extends lazySizes to lazyLoad:
background images, videos/posters and scripts

Background-Image:
For background images, use data-bg attribute:
<div class="lazyload" data-bg="bg-img.jpg"></div>

 Video:
 For video/audio use data-poster and preload="none":
 <video class="lazyload" preload="none" data-poster="poster.jpg" src="src.mp4">
 <!-- sources -->
 </video>

 For video that plays automatically if in view:
 <video
	class="lazyload"
	preload="none"
	muted=""
	data-autoplay=""
	data-poster="poster.jpg"
	src="src.mp4">
</video>

 Scripts:
 For scripts use data-script:
 <div class="lazyload" data-script="module-name.js"></div>


 Script modules using require:
 For modules using require use data-require:
 <div class="lazyload" data-require="module-name"></div>
*/

(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if( true && module.exports){
		factory(__webpack_require__(/*! lazysizes */ "./node_modules/lazysizes/lazysizes.js"));
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! lazysizes */ "./node_modules/lazysizes/lazysizes.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}(window, function(window, document, lazySizes) {
	/*jshint eqnull:true */
	'use strict';
	var bgLoad, regBgUrlEscape;
	var uniqueUrls = {};

	if(document.addEventListener){
		regBgUrlEscape = /\(|\)|\s|'/;

		bgLoad = function (url, cb){
			var img = document.createElement('img');
			img.onload = function(){
				img.onload = null;
				img.onerror = null;
				img = null;
				cb();
			};
			img.onerror = img.onload;

			img.src = url;

			if(img && img.complete && img.onload){
				img.onload();
			}
		};

		addEventListener('lazybeforeunveil', function(e){
			if(e.detail.instance != lazySizes){return;}

			var tmp, load, bg, poster;
			if(!e.defaultPrevented) {

				var target = e.target;

				if(target.preload == 'none'){
					target.preload = target.getAttribute('data-preload') || 'auto';
				}

				if (target.getAttribute('data-autoplay') != null) {
					if (target.getAttribute('data-expand') && !target.autoplay) {
						try {
							target.play();
						} catch (er) {}
					} else {
						requestAnimationFrame(function () {
							target.setAttribute('data-expand', '-10');
							lazySizes.aC(target, lazySizes.cfg.lazyClass);
						});
					}
				}

				tmp = target.getAttribute('data-link');
				if(tmp){
					addStyleScript(tmp, true);
				}

				// handle data-script
				tmp = target.getAttribute('data-script');
				if(tmp){
					e.detail.firesLoad = true;
					load = function(){
						e.detail.firesLoad = false;
						lazySizes.fire(target, '_lazyloaded', {}, true, true);
					};
					addStyleScript(tmp, null, load);
				}

				// handle data-require
				tmp = target.getAttribute('data-require');
				if(tmp){
					if(lazySizes.cfg.requireJs){
						lazySizes.cfg.requireJs([tmp]);
					} else {
						addStyleScript(tmp);
					}
				}

				// handle data-bg
				bg = target.getAttribute('data-bg');
				if (bg) {
					e.detail.firesLoad = true;
					load = function(){
						target.style.backgroundImage = 'url(' + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg ) + ')';
						e.detail.firesLoad = false;
						lazySizes.fire(target, '_lazyloaded', {}, true, true);
					};

					bgLoad(bg, load);
				}

				// handle data-poster
				poster = target.getAttribute('data-poster');
				if(poster){
					e.detail.firesLoad = true;
					load = function(){
						target.poster = poster;
						e.detail.firesLoad = false;
						lazySizes.fire(target, '_lazyloaded', {}, true, true);
					};

					bgLoad(poster, load);

				}
			}
		}, false);

	}

	function addStyleScript(src, style, cb){
		if(uniqueUrls[src]){
			return;
		}
		var elem = document.createElement(style ? 'link' : 'script');
		var insertElem = document.getElementsByTagName('script')[0];

		if(style){
			elem.rel = 'stylesheet';
			elem.href = src;
		} else {
			elem.onload = function(){
				elem.onerror = null;
				elem.onload = null;
				cb();
			};
			elem.onerror = elem.onload;

			elem.src = src;
		}
		uniqueUrls[src] = true;
		uniqueUrls[elem.src || elem.href] = true;
		insertElem.parentNode.insertBefore(elem, insertElem);
	}
}));


/***/ }),

/***/ "./src/assets/scss/take-a-quiz.scss":
/*!******************************************!*\
  !*** ./src/assets/scss/take-a-quiz.scss ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/home-our-range.scss":
/*!*********************************************!*\
  !*** ./src/assets/scss/home-our-range.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/home-signature-flavors-collection.scss":
/*!****************************************************************!*\
  !*** ./src/assets/scss/home-signature-flavors-collection.scss ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/home-about-sec.scss":
/*!*********************************************!*\
  !*** ./src/assets/scss/home-about-sec.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/home-more-to-love.scss":
/*!************************************************!*\
  !*** ./src/assets/scss/home-more-to-love.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/instagram-slider.scss":
/*!***********************************************!*\
  !*** ./src/assets/scss/instagram-slider.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/inner-banner-section.scss":
/*!***************************************************!*\
  !*** ./src/assets/scss/inner-banner-section.scss ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/collection-template.scss":
/*!**************************************************!*\
  !*** ./src/assets/scss/collection-template.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/product-template.scss":
/*!***********************************************!*\
  !*** ./src/assets/scss/product-template.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/main-404-template.scss":
/*!************************************************!*\
  !*** ./src/assets/scss/main-404-template.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/customer-review-slider.scss":
/*!*****************************************************!*\
  !*** ./src/assets/scss/customer-review-slider.scss ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/subscription-template.scss":
/*!****************************************************!*\
  !*** ./src/assets/scss/subscription-template.scss ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/faq-template.scss":
/*!*******************************************!*\
  !*** ./src/assets/scss/faq-template.scss ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/store-locators-template.scss":
/*!******************************************************!*\
  !*** ./src/assets/scss/store-locators-template.scss ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/cart-sidebar-template.scss":
/*!****************************************************!*\
  !*** ./src/assets/scss/cart-sidebar-template.scss ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/nutritional-information-template.scss":
/*!***************************************************************!*\
  !*** ./src/assets/scss/nutritional-information-template.scss ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/terms-conditions-template.scss":
/*!********************************************************!*\
  !*** ./src/assets/scss/terms-conditions-template.scss ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/product-tabs.scss":
/*!*******************************************!*\
  !*** ./src/assets/scss/product-tabs.scss ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/about.scss":
/*!************************************!*\
  !*** ./src/assets/scss/about.scss ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/menu-template.scss":
/*!********************************************!*\
  !*** ./src/assets/scss/menu-template.scss ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/menu-popup.scss":
/*!*****************************************!*\
  !*** ./src/assets/scss/menu-popup.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/account.scss":
/*!**************************************!*\
  !*** ./src/assets/scss/account.scss ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/contact.scss":
/*!**************************************!*\
  !*** ./src/assets/scss/contact.scss ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/login-template.scss":
/*!*********************************************!*\
  !*** ./src/assets/scss/login-template.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/landing-usp.scss":
/*!******************************************!*\
  !*** ./src/assets/scss/landing-usp.scss ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/landing-faq-template.scss":
/*!***************************************************!*\
  !*** ./src/assets/scss/landing-faq-template.scss ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/landing-hero-banner.scss":
/*!**************************************************!*\
  !*** ./src/assets/scss/landing-hero-banner.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/theme.scss":
/*!************************************!*\
  !*** ./src/assets/scss/theme.scss ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/header.scss":
/*!*************************************!*\
  !*** ./src/assets/scss/header.scss ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/footer.scss":
/*!*************************************!*\
  !*** ./src/assets/scss/footer.scss ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/newsletter.scss":
/*!*****************************************!*\
  !*** ./src/assets/scss/newsletter.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/home-hero-section.scss":
/*!************************************************!*\
  !*** ./src/assets/scss/home-hero-section.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/theme/assets/theme": 0,
/******/ 			"theme/assets/home-hero-section": 0,
/******/ 			"theme/assets/newsletter": 0,
/******/ 			"theme/assets/footer": 0,
/******/ 			"theme/assets/header": 0,
/******/ 			"theme/assets/theme": 0,
/******/ 			"theme/assets/landing-hero-banner": 0,
/******/ 			"theme/assets/landing-faq-template": 0,
/******/ 			"theme/assets/landing-usp": 0,
/******/ 			"theme/assets/login-template": 0,
/******/ 			"theme/assets/contact": 0,
/******/ 			"theme/assets/account": 0,
/******/ 			"theme/assets/menu-popup": 0,
/******/ 			"theme/assets/menu-template": 0,
/******/ 			"theme/assets/about": 0,
/******/ 			"theme/assets/product-tabs": 0,
/******/ 			"theme/assets/terms-conditions-template": 0,
/******/ 			"theme/assets/nutritional-information-template": 0,
/******/ 			"theme/assets/cart-sidebar-template": 0,
/******/ 			"theme/assets/store-locators-template": 0,
/******/ 			"theme/assets/faq-template": 0,
/******/ 			"theme/assets/subscription-template": 0,
/******/ 			"theme/assets/customer-review-slider": 0,
/******/ 			"theme/assets/main-404-template": 0,
/******/ 			"theme/assets/product-template": 0,
/******/ 			"theme/assets/collection-template": 0,
/******/ 			"theme/assets/inner-banner-section": 0,
/******/ 			"theme/assets/instagram-slider": 0,
/******/ 			"theme/assets/home-more-to-love": 0,
/******/ 			"theme/assets/home-about-sec": 0,
/******/ 			"theme/assets/home-signature-flavors-collection": 0,
/******/ 			"theme/assets/home-our-range": 0,
/******/ 			"theme/assets/take-a-quiz": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkydm_starter_theme"] = self["webpackChunkydm_starter_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/js/theme.js")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/theme.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/header.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/footer.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/newsletter.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/home-hero-section.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/take-a-quiz.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/home-our-range.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/home-signature-flavors-collection.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/home-about-sec.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/home-more-to-love.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/instagram-slider.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/inner-banner-section.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/collection-template.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/product-template.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/main-404-template.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/customer-review-slider.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/subscription-template.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/faq-template.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/store-locators-template.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/cart-sidebar-template.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/nutritional-information-template.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/terms-conditions-template.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/product-tabs.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/about.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/menu-template.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/menu-popup.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/account.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/contact.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/login-template.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/landing-usp.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/landing-faq-template.scss")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["theme/assets/home-hero-section","theme/assets/newsletter","theme/assets/footer","theme/assets/header","theme/assets/theme","theme/assets/landing-hero-banner","theme/assets/landing-faq-template","theme/assets/landing-usp","theme/assets/login-template","theme/assets/contact","theme/assets/account","theme/assets/menu-popup","theme/assets/menu-template","theme/assets/about","theme/assets/product-tabs","theme/assets/terms-conditions-template","theme/assets/nutritional-information-template","theme/assets/cart-sidebar-template","theme/assets/store-locators-template","theme/assets/faq-template","theme/assets/subscription-template","theme/assets/customer-review-slider","theme/assets/main-404-template","theme/assets/product-template","theme/assets/collection-template","theme/assets/inner-banner-section","theme/assets/instagram-slider","theme/assets/home-more-to-love","theme/assets/home-about-sec","theme/assets/home-signature-flavors-collection","theme/assets/home-our-range","theme/assets/take-a-quiz"], () => (__webpack_require__("./src/assets/scss/landing-hero-banner.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;